import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { ORDER_GET_ONE } from 'api/query-keys.ts';
import type { TOrderRes } from 'api/swagger';

export const useGetOrder = (id?: number) => {
  return useQuery<TOrderRes>({
    queryKey: [ORDER_GET_ONE, id],
    queryFn: async ({ signal }) => {
      const { data } = await http.get<TOrderRes>(`/v1/orders/${id}`, { signal });
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 60 * 1000,
    enabled: !!id,
  });
};
